"use strict";

var e = require("./_commonjsHelpers-f10b257f.js"),
  r = e.createCommonjsModule(function (e) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  t = e.createCommonjsModule(function (e) {
    e.exports = function (e, r) {
      var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != t) {
        var o,
          n,
          s,
          u,
          l = [],
          a = !0,
          i = !1;
        try {
          if (s = (t = t.call(e)).next, 0 === r) {
            if (Object(t) !== t) return;
            a = !1;
          } else for (; !(a = (o = s.call(t)).done) && (l.push(o.value), l.length !== r); a = !0);
        } catch (e) {
          i = !0, n = e;
        } finally {
          try {
            if (!a && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
          } finally {
            if (i) throw n;
          }
        }
        return l;
      }
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  o = e.createCommonjsModule(function (e) {
    e.exports = function (e, r) {
      (null == r || r > e.length) && (r = e.length);
      for (var t = 0, o = new Array(r); t < r; t++) o[t] = e[t];
      return o;
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  n = e.createCommonjsModule(function (e) {
    e.exports = function (e, r) {
      if (e) {
        if ("string" == typeof e) return o(e, r);
        var t = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? o(e, r) : void 0;
      }
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  s = e.createCommonjsModule(function (e) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  u = e.createCommonjsModule(function (e) {
    e.exports = function (e, o) {
      return r(e) || t(e, o) || n(e, o) || s();
    }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
  }),
  l = e.getDefaultExportFromCjs(u);
exports._slicedToArray = l, exports.arrayLikeToArray = o, exports.unsupportedIterableToArray = n;